export default "__VITE_ASSET__Ck8KQqJK__"